import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import SponsoredAdverts from './subrouters/SponsoredAdverts';
import sponsoredAdversRoutes from './subrouters/SponsoredAdverts/routes';
import AdminDashboard from './pages/AdminDashboard';
import BrokerList from './pages/BrokerList';
import BossModeStats from './pages/BossModeStats';
import ListingMetrics from './pages/ListingMetrics';
import EnterpriseRouter from './subrouters/Enterprises';
import enterpriseRoutes from './subrouters/Enterprises/routes';
import ProfileRouter, { profileRouterRoutes } from '../Profile';
import { RoutingStep } from 'router/models/Routes';
import BossModeAccounts from './pages/BossModeAccounts';
// import ActivityMetrics from './pages/ActivityMetrics';

const bossModeEditProfileRoutes = profileRouterRoutes.filter(
  ({ path }: RoutingStep) => path !== 'account',
);

type AdminDashobardRoutes = EnhancedRouteProps & {
  labelString?: string;
  labelDescription?: string;
};

export default [
  {
    path: 'sponsored-adverts',
    element: SponsoredAdverts,
    routes: sponsoredAdversRoutes,
    labelString: 'sponsoredAdverts',
    labelDescription: 'sponsoredAdvertsDescription',
  },
  {
    path: 'broker-list',
    element: BrokerList,
    labelString: 'addABroker',
    labelDescription: 'addABrokerDescription',
  },
  {
    path: 'boss-mode-stats',
    element: BossModeStats,
    labelString: 'bossModeMetrics',
    labelDescription: 'internalDashboard',
  },
  {
    path: 'listing-metrics',
    element: ListingMetrics,
    labelString: 'listingMetrics',
    labelDescription: 'internalDashboard',
  },
  // {
  //   path: 'activity-metrics',
  //   element: ActivityMetrics,
  //   labelString: 'activityMetrics',
  //   labelDescription: 'internalDashboard',
  // },
  {
    path: 'enterprise',
    element: EnterpriseRouter,
    routes: enterpriseRoutes,
    labelString: 'manageEnterprises',
    labelDescription: 'enterpriseDescription',
  },
  {
    path: 'boss-mode-accounts',
    element: BossModeAccounts,
    labelString: 'editBossModeAccounts',
    labelDescription: 'bossModeAccountsDescription',
  },
  {
    path: 'edit-profile/:id',
    element: ProfileRouter,
    routes: bossModeEditProfileRoutes,
  },
  { index: true, element: AdminDashboard },
] as Array<AdminDashobardRoutes>;
